import { useMemo, useEffect, useCallback } from 'react';

import { useSetState } from 'src/hooks/use-set-state';

import axios, { endpoints } from 'src/utils/axios';

import { AuthContext } from '../auth-context';

// ----------------------------------------------------------------------

export function AuthProvider({ children }) {
  const { state, setState } = useSetState({
    user: null,
    loading: true,
  });

  const checkUserSession = useCallback(async () => {
    try {
      const res = await axios.get(endpoints.auth.me);
      const user = res.data;
      const displayName =
        [user.firstName, user.lastName].filter(Boolean).join(' ') ||
        user.username ||
        user.email ||
        user.mobile ||
        'کاربر رادو';

      setState({
        user: {
          ...user,
          displayName,
          photoURL: user.profileImageKey
            ? `${endpoints.profile}/image?v=${encodeURIComponent(user.profileImageKey)}-${Date.now()}`
            : null,
          role: user.activeContext?.activeRoleName,
        },
        loading: false,
      });
      return true;
    } catch (error) {
      if (error?.status !== 401) {
        console.error(error);
      }
      setState({ user: null, loading: false });
      return false;
    }
  }, [setState]);

  useEffect(() => {
    checkUserSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ----------------------------------------------------------------------

  const checkAuthenticated = state.user ? 'authenticated' : 'unauthenticated';

  const status = state.loading ? 'loading' : checkAuthenticated;

  const memoizedValue = useMemo(
    () => ({
      user: state.user,
      checkUserSession,
      loading: status === 'loading',
      authenticated: status === 'authenticated',
      unauthenticated: status === 'unauthenticated',
    }),
    [checkUserSession, state.user, status]
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}
